<template>
	<section>

		<b-tabs v-model="activeTab" @change="loadTabById" ref="tabs" v-if="$store.getters['Auth/hasPermission']('can only manage codes list')">

			<b-tab-item label="List" id="tab-list">
				<codes-list-page :firm="firm" v-if="isTabLoaded('tab-list')"></codes-list-page>
			</b-tab-item>

		</b-tabs>

		<b-tabs v-model="activeTab" @change="loadTabById" ref="tabs" v-else>

			<b-tab-item label="List" id="tab-list">
            	<codes-list-page :firm="firm" v-if="isTabLoaded('tab-list')"></codes-list-page>
            </b-tab-item>

            <b-tab-item label="Codes" id="tab-codes">
				<div class="columns" v-if="isTabLoaded('tab-codes')">
					<div class="column no-wrap" style="max-width:50%;">
						<div class="code-header">Persons</div>
						<div style="height:calc(90vh - 50px - 100px); overflow-y:scroll;">
							<Persons :organization="organization" :firm="firm" :selectedPersons.sync="selectedPersons" />
						</div>
						<b-button expanded type="is-info" :disabled="assignDisabled" @click="assignCodes">ASSIGN CODES</b-button>
					</div>
					<div class="column" style="width:100%;">
						<div class="code-header">Codes</div>
						<div style="height:calc(90vh - 50px - 100px); overflow-y:scroll;">
							<Codes :organization="organization" :firm="firm" :selectedCodes.sync="selectedCodes" />
						</div>
					</div>
				</div>
            </b-tab-item>

			<b-tab-item label="Configurator" id="tab-configurator">
				<code-configurator-page :firm="firm" v-if="isTabLoaded('tab-configurator')"></code-configurator-page>
			</b-tab-item>

			<b-tab-item label="Matrix Manager" id="tab-matrix-manager">
				<codes-matrix-manager-page v-if="isTabLoaded('tab-matrix-manager')"></codes-matrix-manager-page>
			</b-tab-item>

			<b-tab-item label="Chain" id="tab-chain">
				<codes-chain-page v-if="isTabLoaded('tab-chain')"></codes-chain-page>
			</b-tab-item>

			<b-tab-item label="Master" id="tab-master">
				<code-table
					:firm-id="organization.id"
					v-if="isTabLoaded('tab-master')"
				/>
			</b-tab-item>

        </b-tabs>

	</section>
</template>

<script>

	import Persons from "./persons";
	import Codes from "./codes";
	import { UserService } from "@/services/user.service";
	import { tabsMixin } from "@/mixins/tabsMixin";

	import CodesListPage from "@/components/pages/Codes/list";
	import CodeConfiguratorPage from "@/components/pages/codeConfigurator";
	import CodesMatrixManagerPage from "@/components/pages/CodesMatrixManager";
	import CodesChainPage from "@/components/pages/Codes/chain";
	import CodeTable from "@/components/Code/CodeTable";

	export default {
		props: [ 'firm', 'organization' ],
	    mixins: [tabsMixin],
		components: {
	        Persons,
	        Codes,
	        CodesListPage,
			CodeConfiguratorPage,
			CodesMatrixManagerPage,
			CodesChainPage,
			CodeTable,
	    },
	    data: () => ({
	        activeTab: 0,
	    	selectedCodes: [],
	    	selectedPersons: []
	    }),
	    computed: {
	    	assignDisabled() {
	    		return ! this.selectedCodes.length || ! this.selectedPersons.length;
	    	},
			},
			mounted() {
				// Load initial tab
	    	this.loadTabById(0);
			},
	    methods: {
	    	assignCodes() {
	    		UserService.assignCodes({ person_ids: this.selectedPersons, code_ids: this.selectedCodes }).then(response => {
	    			this.$buefy.toast.open({
						message: "Success",
						type: "is-success",
						position: "is-top-right"
			        });
	    		});
	    	}
	    }
	};

</script>

<style scoped>
	.code-header {
		background-color:#424242;
		padding:7px 10px;
		margin-bottom:10px;
		color:white;
		font-size: 14px;
    	font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/codes/index.vue